export class EmailSettings {

    title: string;

    subject: string;

    message: string;

}
